import { GxVirtualKeyCardInReservation } from '@mews-commander/data-access';
import { useDigitalKeyReservationStatusQuery } from '../queries/useDigitalKeyReservationStatusQuery';

export const useIsDigitalKeyStatus = (reservationId?: string) => {
    const { data } = useDigitalKeyReservationStatusQuery(reservationId || '');
    return data?.reservationDigitalKeyStatusResults?.[0]?.status === GxVirtualKeyCardInReservation.AlreadyIssued;
};
